import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  TextField,
  Grid,
  IconButton,
  Typography,
  Divider,
  InputAdornment,
  Autocomplete,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { getGlobals } from "../../../Configs";
import { useSelector } from "react-redux";
import {
  ReportRemoveSequenceChar,
  ReportTitle,
  ReportUrl,
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import { confirmAlert } from "react-confirm-alert";
import { exportToExcel } from "../../ItemApprove/ItemApproveRequestAction";
import DetailComponent from "./DetailComponent";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import GCWebReport from "../../../Component/Common/ReuseableComponent/GCWebReport";

const BoxPalletReceiptDetail = ({
  open,
  closeModal = () => {},
  vMediaQuery,
  uMediaQuery,
  rowData = [],
  xMediaQuery,
  trnType,
}) => {
  const yMediaQuery = useMediaQuery("(max-width:1200px)");
  const aMediaQuery = useMediaQuery("(max-width:335px)");
  const sMediaQuery = useMediaQuery("(min-width:336px) and (max-width:405px)");
  const baseURL = getGlobals().API_BASE_URL;
  const [settingDetail, setSettingDetail] = useState([]);
  const vRdxuserInfo = useSelector((state) => state.login.value);

  const [selectedRow, setSelectedRow] = useState("");
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);

  console.log("rowData", rowData);
  let headInitObj = {
    vocNo: rowData?.A_VocNo || 0,
    location: rowData?.A_Loc || vRdxuserLoc[0]?.UID,
    truckId: {
      UId: rowData?.A_TruckId || "",
      Name1: rowData?.TrucK_Name || "",
    },
    // truckName : rowData?.TrucK_Name || "",
    status: rowData?.A_Status,
  };
  const [headObj, setHeadObj] = useState(headInitObj);

  let detailInitObj = {
    srNo: 0,
    barcode: "",
    itemCode: "",
    itemName: "",
    qty: 1,
  };

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sWebReportModal, setWebReportModal] = React.useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = React.useState("");

  const fPrint = async () => {
    if (headObj?.vocNo) {
      let urlPrint = vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val;
      let sCurrentReport = "";
      let sReportTitle = "";

      let ReportTitleObj = {
        VocNo: headObj?.vocNo, // "LD001"
      };
      // Remove the trailing "&" character
      sReportTitle = ReportTitle(ReportTitleObj);

      let ReportUrlObj = {
        VocNo: headObj?.vocNo, // "LD001"

        // reportTitle: sReportTitle,
      };
      console.log(ReportUrlObj);
      sCurrentReport = ReportUrl(ReportUrlObj);
      sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);
      // console.log("ReportUrlObj", ReportUrlObj);
      console.log("sCurrentReport", sCurrentReport);
      console.log(
        "sCurrentReport",
        urlPrint + "WMS/BoxPalletReceipt?" + sCurrentReport
      );
      setWebReportUrlModal(urlPrint + "WMS/BoxPalletReceipt?" + sCurrentReport);
      setWebReportModal(true);
    } else {
      fAlertToast("FAILED", "VOC NO  NOT FOUND");
    }
  };
  const handleTruckChange = (event) => {
    const { name, value } = event.target;

    setHeadObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [detailObj, setDetailObj] = useState(detailInitObj);

  const handleDetailChange = (event) => {
    const { name, value } = event.target;

    setDetailObj((prev) => {
      const updatedDetailObj = {
        ...prev,
        [name]: value,
      };
      if (name === "qty") {
        const numericValue = Number(value);
        updatedDetailObj.qty = !isNaN(numericValue)
          ? Math.round(numericValue)
          : 0;
      }
      // Reset fields if barcode is empty or backspace is pressed
      if (name == "barcode") {
        if (
          updatedDetailObj?.barcode.trim() === "" ||
          event.nativeEvent.inputType === "deleteContentBackward"
        ) {
          updatedDetailObj.barcode = value;
          updatedDetailObj.itemCode = "";
          updatedDetailObj.itemName = "";
          updatedDetailObj.qty = 1;
        }
      }

      return updatedDetailObj;
    });

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  let initHeadError = {
    vocNo: "",
    location: "",
    truckId: "",
  };
  const [headErrors, setHeadErrors] = useState(initHeadError);

  let initError = {
    srNo: "",
    barcode: "",
    itemCode: "",
    itemName: "",
  };
  const [errors, setErrors] = useState(initError);

  const fValidationHead = () => {
    let isValid = true;

    const newError = {
      vocNo: "",
      location: "",
      truckId: "",
    };
    console.log(">>", headObj?.truckId);
    if (
      headObj?.vocNo === "" ||
      headObj?.vocNo == undefined ||
      headObj?.vocNo === null
    ) {
      newError.vocNo = "Voc.No is required.";
      isValid = false;
    }

    if (
      headObj?.location == "" ||
      headObj?.location == undefined ||
      headObj?.location === null
    ) {
      newError.location = "Location is required.";
      isValid = false;
    }
    if (
      headObj?.truckId.UId == "" ||
      headObj?.truckId.UId == undefined ||
      headObj?.truckId.UId === null
    ) {
      console.log("Validation failed: Truck ID is required.");
      newError.truckId = "Truck ID is required.";
      isValid = false;
    }

    setHeadErrors((prevError) => ({
      ...prevError,
      ...newError,
    }));

    if (!isValid) {
      const firstInvalidField = Object.keys(newError).find(
        (key) => newError[key]
      );
      document.querySelector(`[name="${firstInvalidField}"]`)?.focus();
    }

    return isValid;
  };

  const fValidationDetail = () => {
    let isValid = true;

    const newError = {
      srNo: "",
      barcode: "",
      itemCode: "",
      itemName: "",
      qty: "",
    };
    if (
      detailObj?.srNo === "" ||
      detailObj?.srNo == undefined ||
      detailObj?.srNo === null
    ) {
      newError.srNo = "SrNo is required.";
      isValid = false;
    }
    if (
      detailObj?.barcode === "" ||
      detailObj?.barcode == undefined ||
      detailObj?.barcode === null
    ) {
      newError.barcode = "BarCode is required.";
      isValid = false;
    }
    if (
      detailObj?.itemCode === "" ||
      detailObj?.itemCode == undefined ||
      detailObj?.itemCode === null
    ) {
      newError.itemCode = "Item Code is required.";
      isValid = false;
    }
    if (
      detailObj?.itemName === "" ||
      detailObj?.itemName == undefined ||
      detailObj?.itemName === null
    ) {
      newError.itemName = "Item Name is required.";
      isValid = false;
    }

    setErrors((prevError) => ({
      ...prevError,
      ...newError,
    }));

    // Focus on the first invalid field
    if (!isValid) {
      document.getElementById("ItemName")?.focus();
    }

    return isValid;
  };

  const ftruckIdScan = (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      //  setHeadErrors(initHeadError);
      // const isHeadValid = fValidationHead();
      // if (!isHeadValid) return;
      getTruckId();
    }
  };

  const getTruckId = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}WmsBoxPallet/AttributesBoxPalletTruck`,
        {
          TruckId: headObj?.truckId,
        }
      );

      if (response?.status === 200) {
        let result = response?.data?.ResultSet.TruckRec;
        if (result.length > 0) {
          setHeadObj((prev) => ({
            ...prev,
            truckId: response?.data?.ResultSet.TruckRec[0],
          }));
        } else {
          fAlertToast("FAILED", "Truck Id not found");
        }
      }
      setHeadErrors(initHeadError);
      document.getElementById("barcode")?.focus();
    } catch (error) {
      console.error("Error fetching cycle count data:", error);
    } finally {
      loader.style.display = "none";
    }
  };

  const handleRowClick = (row) => {
    setSelectedRow(row);
    setDetailObj((prev) => ({
      ...prev,
      srNo: row?.B_SrNo || 0,
      barcode: row?.B_Barcode || "",
      itemCode: row?.B_ItmCd || "",
      itemName: row?.Itm_Name || "",
      qty: row?.B_Qty || "",
    }));
    setErrors(initError);
    setTimeout(() => {
      document.getElementsByName("qty")[0].focus();
    }, 600);
  };
  console.log(headObj);

  useEffect(() => {
    if (open) {
      getRowApi();
    }
    if (headObj?.vocNo == 0) {
      setTimeout(() => {
        document.getElementById("TruckId")?.focus();
      }, 800);
    } else {
      setTimeout(() => {
        document.getElementById("barcode")?.focus();
      }, 500);
    }
  }, [open, headObj?.vocNo]);

  const getRowApi = async (Vocno = headObj?.vocNo) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}WmsBoxPallet/BoxPalletReceivingDetail_GetRow`,
        fcheck_null_undefine_replace_empty({
          VocNo: Vocno,
        })
      );

      if (response?.status === 200) {
        setSettingDetail(response?.data?.ResultSet);
        loader.style.display = "none";
      }
    } catch (error) {
      loader.style.display = "none";
    }
  };

  const getBarcodeApi = async () => {
    try {
      const response = await axios.post(
        `${baseURL}WmsBoxPallet/getBarcodeDetailScanBasket`,
        fcheck_null_undefine_replace_empty({
          Barcode: detailObj?.barcode,
          Loc: headObj?.location,
        })
      );

      if (response?.status === 200) {
        let result = response?.data?.ResultSet;

        if (result?.length > 0) {
          setDetailObj((pre) => ({
            ...pre,
            barcode: result[0]?.Barcode,
            itemCode: result[0]?.ItmCd,
            itemName: result[0]?.Name2,
            // srNo : result[0]
            //  unit: result[0]?.Unit,
          }));
          setErrors(initError);
        } else {
          fAlertToast("FAILED", "Barcode not found");
        }
        document.getElementsByName("qty")[0].focus();
      } else {
        fAlertToast("FAILED", "Failed to fetch barcode details");
      }
    } catch (error) {
      console.error("Error fetching cycle count data:", error);
      fAlertToast("ERROR", "An error occurred while scanning the barcode");
    }
  };

  const fbarcodeScan = (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      getBarcodeApi();
    }
  };

  const saveApi = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}WmsBoxPallet/updateBoxPalletReceivingHeadDetail`,
        fcheck_null_undefine_replace_empty({
          VocNo: headObj?.vocNo,
          Loc: headObj?.location,
          TruckId: headObj?.truckId[0]?.UId || headObj?.truckId?.UId,
          SrNo: detailObj?.srNo,
          Barcode: detailObj?.barcode,
          ItmCd: detailObj?.itemCode,
          Qty: detailObj?.qty,
          UserCd: vRdxuserInfo?.UserID,
          IO: trnType,
        })
      );

      // Assuming response data structure is an array of objects
      if (response?.status === 200) {
        const newSrNo = response?.data?.ResultSet[0]?.B_SrNo;
        const newVocNo = response?.data?.ResultSet[0]?.A_VocNo;

        if (response?.data?.ResultSet?.length > 0) {
          setDetailObj((prev) => ({
            ...prev,
            srNo: newSrNo,
          }));
          setHeadObj((prev) => ({
            ...prev,
            vocNo: newVocNo,
          }));
        }
        fAlertToast("SUCCESS", "Line items saved successfully");
        loader.style.display = "none";
        fNewDetail(newVocNo);
      }
    } catch (error) {
      loader.style.display = "none";
      console.error("Error fetching cycle count data:", error);
      let errorMessage =
        error?.response?.data?.message?.msg ||
        error?.response?.data?.error ||
        "An unexpected error occurred.";

      fAlertToast("FAILED", `${errorMessage}`);
    }
  };

  const postApi = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}WmsBoxPallet/postBoxPalletReceivingHead`,
        fcheck_null_undefine_replace_empty({
          VocNo: headObj?.vocNo,
          UserCd: vRdxuserInfo?.UserID,
        })
      );

      // Assuming response data structure is an array of objects
      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Transaction posted successfully");
        loader.style.display = "none";
        fNewDetail();
        closeModal();
      }
    } catch (error) {
      let errorMessage =
        error?.response?.data?.message?.msg ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurred.";

      fAlertToast("FAILED", `${errorMessage}`);
      loader.style.display = "none";
    }
  };
  const deleteRowApi = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}WmsBoxPallet/deleteBoxPalletReceivingDetail`,
        fcheck_null_undefine_replace_empty({
          VocNo: headObj?.vocNo,
          SrNo: selectedRow?.B_SrNo,
          UserCd: vRdxuserInfo?.UserID,
        })
      );

      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Line items deleted successfully");
        fNewDetail();
        loader.style.display = "none";
      }
    } catch (error) {
      let errorMessage =
        error?.response?.data?.message?.msg ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurred.";

      fAlertToast("FAILED", `${errorMessage}`);
      loader.style.display = "none";
    }
  };
  const fSave = () => {
    setErrors(initError);
    setHeadErrors(initHeadError);
    const isHeadValid = fValidationHead();
    if (!isHeadValid) return;

    const isDetailValid = fValidationDetail();
    if (!isDetailValid) return;
    saveApi();
    setTimeout(() => {
      document.getElementsByName("itemName")[0].focus();
    }, 600);
  };

  const fPost = () => {
    setErrors(initError);
    setHeadErrors(initHeadError);

    let validation = fValidationHead();
    if (!validation) return;

    if (settingDetail?.length == 0) {
      fAlertToast("INFO", "Add atleast one line item");
      return;
    }
    confirmAlert({
      title: "Approve",
      message: "Are you want to Approve?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            postApi();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };
  const fDelete = () => {
    confirmAlert({
      title: "Delete",
      message: "Are you want to delete?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            deleteRowApi();

            setTimeout(() => {
              document.getElementsByName("itemName")[0].focus();
            }, 600);
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };

  const handleAddNew = () => {
    if (detailObj?.itemName === "" && detailObj?.barcode == "") {
      fHead();
      setTimeout(() => {
        document.getElementsByName("TruckId")[0].focus();
      }, 500);
    } else {
      fNewDetail();
    }
  };

  const fNewDetail = async (Vocno = headObj?.vocNo) => {
    setDetailObj((prev) => ({
      ...prev,
      srNo: 0,
      barcode: "",
      itemCode: "",
      itemName: "",
      qty: 1,
    }));
    setErrors(initError);
    await getRowApi(Vocno);
    setTimeout(() => {
      document.getElementsByName("barcode")[0].focus();
    }, 600);
  };

  const fHead = () => {
    setHeadObj((prev) => ({
      ...prev,
      vocNo: 0,
      location: vRdxuserLoc[0]?.UID,
      truckId: {
        UId: "",
        Name1: "",
      },

      status: "ENTER",
    }));
    getRowApi();
    setHeadErrors(initHeadError);
    setTimeout(() => {
      document.getElementsByName("location")[0].focus();
    }, 500);
  };
  const fExport = () => {
    exportToExcel(settingDetail, "StockSettingDetail", "StockSettingDetail");
  };

  return (
    <Box className="stock-detail">
      <Grid
        container
        columnSpacing={{ xs: 1.1, sm: 1, md: 2, lg: 2 }}
        rowSpacing={1}
        mt={vMediaQuery ? 1 : 0}
      >
        <Grid item xs={5} sm={2.5} md={3} lg={1.5}>
          <Typography>Voc No</Typography>
          <TextField fullWidth value={headObj?.vocNo} disabled />
        </Grid>
        <Grid item xs={7} sm={6} md={5} lg={3}>
          <Typography>Location</Typography>
          <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            name="location"
            options={vRdxuserLoc}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.Name1
            }
            value={
              vRdxuserLoc?.find((loc) => loc.UID === headObj?.location) || null
            }
            onChange={(event, newValue) => {
              if (typeof newValue === "string") {
                setHeadObj((prev) => ({
                  ...prev,
                  location: newValue,
                }));
              } else if (newValue) {
                setHeadObj((prev) => ({
                  ...prev,
                  location: newValue.Uid,
                }));
              }
              setHeadErrors((prev) => ({
                ...prev,
                location: "",
              }));
            }}
            onInputChange={(event, newValue, reason) => {
              if (reason === "clear" || newValue === "") {
                setHeadObj((prev) => ({
                  ...prev,
                  location: "",
                }));
              }
            }}
            disabled={settingDetail.length > 0}
            renderInput={(params) => (
              <TextField
                {...params}
                error={headErrors?.location === "" ? false : true}
                helperText={headErrors?.location}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    type: "search",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={3.5} md={4} lg={2.5}>
          <Typography>Truck Id</Typography>
          <TextField
            value={headObj?.truckId[0]?.Name1 || headObj?.truckId.Name1}
            fullWidth
            id="TruckId"
            name="truckId"
            onChange={handleTruckChange}
            onKeyDown={ftruckIdScan}
            autoComplete="off"
            error={headErrors?.truckId === "" ? false : true}
            helperText={headErrors?.truckId}
            sx={{
              "& .MuiOutlinedInput-root": {
                paddingRight: "0px !important",
              },
              "& .MuiInputBase-input": {
                padding: "5.5px 0px 5.5px 10px !important",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={ftruckIdScan}
                    sx={{
                      "& .MuiButtonBase-root": {
                        padding: "0px !important",
                      },
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={5}
          textAlign={vMediaQuery ? "center" : "right"}
        >
          <Button
            variant="contained"
            sx={{
              height: "30px",
              mt: yMediaQuery ? 0 : 2,
              mr: 1,
              textTransform: "capitalize",
            }}
            onClick={handleAddNew}
          >
            New
          </Button>
          <Button
            variant="contained"
            sx={{
              height: "30px",
              mt: yMediaQuery ? 0 : 2,
              mr: 1,
              textTransform: "capitalize",
            }}
            disabled={headObj?.status !== "ENTER"}
            onClick={fSave}
          >
            Save
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              height: "30px",
              mr: 1,
              mt: yMediaQuery ? 0 : 2,
              textTransform: "capitalize",
            }}
            disabled={
              headObj?.status !== "ENTER" ||
              detailObj?.barcode === "" ||
              settingDetail?.length == 0
            }
            onClick={fDelete}
          >
            Delete
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              height: "30px",
              mt: aMediaQuery ? 1 : yMediaQuery ? 0 : 2,
              mr: 1,
              textTransform: "capitalize",
            }}
            disabled={headObj?.status !== "ENTER" || settingDetail?.length == 0}
            onClick={() => {
              if (detailObj?.itemName !== "") {
                fAlertToast("FAILED", "save current line item");
              } else {
                fPost();
              }
            }}
          >
            Post
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{
              height: "30px",
              mt: aMediaQuery || sMediaQuery ? 1 : yMediaQuery ? 0 : 2,
              textTransform: "capitalize",
            }}
            onClick={() => fPrint()}
          >
            Print
          </Button>
        </Grid>
      </Grid>
      <Divider sx={{ mt: xMediaQuery ? 1.5 : 2 }} />

      <DetailComponent
        itemDetails={detailObj}
        setDetailObj={setDetailObj}
        handleDetailChange={handleDetailChange}
        fbarcodeScan={fbarcodeScan}
        errors={errors}
        fExport={fExport}
        vMediaQuery={vMediaQuery}
        xMediaQuery={xMediaQuery}
        setErrors={setErrors}
      />
      <Box
        sx={{
          mt: 2,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          height: "64vh",
          width: "100%",
        }}
      >
        <DataGrid
          rowHeight={30}
          headerHeight={40}
          components={{
            Toolbar: GridToolbar,
          }}
          rows={settingDetail ? settingDetail : ""}
          getRowId={(v) => v.B_SrNo}
          columns={[
            {
              field: "B_Barcode",
              headerName: "Barcode",
              width: xMediaQuery ? 120 : 150,
            },
            {
              field: "B_ItmCd",
              headerName: "Item Code",
              width: xMediaQuery ? 100 : 150,
            },
            {
              field: "Itm_Name",
              headerName: "Item Name",
              width: xMediaQuery ? 220 : 0,
              flex: xMediaQuery ? 0 : 1,
            },
            {
              field: "B_Qty",
              headerName: "Qty",
              width: 80,
              headerAlign: "center",
              align: "center",
            },
          ]}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
          }}
          onRowClick={(params) => handleRowClick(params.row)}
          hideFooter
        />
      </Box>
      <GCWebReport
        xfCloseWebReportModal={() => setWebReportModal(false)}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </Box>
  );
};

export default BoxPalletReceiptDetail;
